/* angular:styles/component:css;3b27e59219481fddf72e5aaa611279d4d3dfed04ad401348e9cfde8d6a10abb5;/home/vsts/work/1/s/projects/fitnessforservice/src/app/help/help.component.ts */
h2 {
  font-family:
    GothamBold,
    Arial,
    sans-serif;
  margin: 16px 15px;
}
/*# sourceMappingURL=help.component.css.map */
